<!-- 
 -->
<template lang="pug">
  .schedule(v-if="loadingReaders")
    //- 排期主版面
    .schedule-main
      .schedule-toolbar.clearfix
        //- 抄表员选择器
        SmartForm.schedule-form(
          :inline="true"
          :columnsLabelShow="false"
          :formList="toolbarList"
          :columns="toolbarColumns"
          :values="toolbarValues"
          :buttonList="buttonList")
        //- 状态标签
        LabelList.schedule-labelList(:labelList="labelTree")
      .schedule-calendar
        //- 排期日历
        Calendar(
          :currentMonth="currentMonth"
          :taskList="workBooks"
          @changeTask="changeWorkBooks"
          @clickTask="submitTask"
          @clickDay="submitDay")
    //- 排期右侧边栏
    .schedule-sidebar
      //- 月份选择器
      .schedule-monthPicker
        MonthPicker(
          :currentMonth="currentMonth"
          @changeMonth="changeMonth")
      //- 未排期区本
      BookList.schedule-bookList(
        :bookList="readyBooks"
        @changeBookList="changeReadyBooks")
</template>

<script>
import { groupBy, keyBy, values } from 'lodash'
import { fetch, fetchList, fetchCreate } from '@/utils/api'
import { treeFormat } from '@/utils/common'
import Calendar from '@/components/Calendar'
import MonthPicker from '@/components/MonthPicker'
import SmartForm from '@/components/SmartForm'
import LabelList from './LabelList'
import BookList from './BookList'
import { expire } from '@/utils/auth'

/**
 * 抄表排期页面
 * @vue MeterReading/Schedule
 */
export default {
  name: 'Schedule',
  components: {
    Calendar,
    MonthPicker,
    SmartForm,
    BookList,
    LabelList
  },
  data () {
    return {
      /**
       * 读取抄表员列表状态
       */
      loadingReaders: false,
      /*
       * 当前抄表员
       */
      currentUser: null,
      /*
       * 工具栏内容列表
       */
      toolbarList: ['reader'],
      /*
       * 工具栏表单字段定义
       */
      toolbarColumns: {
        reader: {
          label: '抄表员',
          form: {
            type: 'select',
            width: 200,
            size: 'md',
            options: [],
            chains: [{
              type: 'function',
              funcProps: {
                schedule: this
              },
              func ({funcProps, value}) {
                const { schedule } = funcProps
                schedule.currentUser = value
                schedule.getBooks() // 选择抄表员时重新读取区本
              }
            }]
          }
        }
      },
      /*
       * 工具栏表单值
       */
      toolbarValues: {},
      /**
       * 抄表状态标签列表
      */
      buttonList: [],
      // buttonList: [{
      //   label: '提交默认排期',
      //   funcProps: {
      //     schedule: this
      //   },
      //   func ({funcProps}) {
      //     const { schedule } = funcProps
      //     schedule.submitDefault()
      //   }
      // }, {
      //   label: '生成全部任务',
      //   funcProps: {
      //     schedule: this
      //   },
      //   func ({funcProps}) {
      //     const { schedule } = funcProps
      //     schedule.submitSchedule()
      //   }
      // }],
      /**
       * 抄表状态标签树状显示
      */
      labelTree: [],
      /**
       * 抄表状态标签列表
      */
      labelList: [],
      /**
       * 当前选择的月份
      */
      currentMonth: '',
      /**
       * 未排期区本
      */
      readyBooks: [],
      /**
       * 已排期区本
      */
      workBooks: {},
      /**
       * 第几次监听进行中的任务，用于防止重复监听
      */
      listenProgressTimes: 0,
      /**
       * 进行中的任务明细
      */
      destroy: false,
      progress: {
        generatingNum: 0,
        readingNum: 0,
        backingNum: 0
      }
    }
  },
  created () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.getRelation() // 页面渲染完成读取relation
  },
  beforeDestroy () {
    this.destroy === true
  },
  destroyed () {
    clearTimeout(this.progressListener)
  },
  methods: {
    /**
     * 读取关联数据：抄表状态
     */
    getRelation () {
      fetch({
        url: 'relation',
        params: {
          relationList: 'scheduleStatus'
        }
      }).then((data) => {
        this.labelList = data.scheduleStatus
        this.labelTree = treeFormat(data.scheduleStatus, 'value', 'pvalue')
        this.getReaders()
      })
    },
    /**
     * 读取抄表员列表
     */
    getReaders () {
      fetchList({
        resource: 'meterReading/readingUser'
      }).then((data) => {
        if (data) {
          const users = data.data
          this.toolbarColumns.reader.options = users.map(({id, name}) => ({
            value: id,
            label: name
          }))
          this.toolbarValues.reader = users[0].id
          this.currentMonth = this.$moment().startOf('month').format('x')
          this.currentUser = users[0].id
          this.listenProgress(this.listenProgressTimes + 1)
        }
        this.loadingReaders = true
      })
    },
    /**
     * 读取区本信息，把区本信息分为已排期区本和未排期区本，分别填入日历和区本列表
     */
    getBooks () {
      if (this.currentUser) {
        const labels = keyBy(this.labelList, 'value')
        fetch({
          method: 'get',
          url: `meterReading/schedule/${this.currentUser}`,
          params: {
            workYearMonth: this.currentMonth
          }
        }).then((data) => {
          // 未排期区本
          this.readyBooks = data.data.filter(book => book.scheduleStatusId === 'NEW').map(item => {
            return {
              ...item,
              label: item.bookName,
              enable: true
            }
          })
          // 已排期区本
          this.workBooks = groupBy(data.data.filter(book => book.scheduleStatusId !== 'NEW').map(item => {
            const status = item.scheduleStatusId
            console.log(item)
            return {
              ...item,
              ...labels[status],
              label: item.bookName,
              enable: status === 'SCHEDULED' || status === 'GENERAL_FAIL'
            }
          }), (item) => {
            return (item.workDate - ((item.workDate + 28800000) % 86400000)).toString()
          })
        })
      }
    },
    /**
     * 修改排期年月
     * @param { String } year - 年
     * @param { String } month - 月
     */
    changeMonth (year, month) {
      this.currentMonth = this.$moment(year + '-' + month, 'YYYY-MM').format('x')
      this.getBooks() // 重新读取区本信息
    },
    /**
     * 已排期区本拖到未排期区本列表
     * @param { Number } index - 未排期区本的位置
     * @param { Object } item - 区本项
     */
    changeReadyBooks ({index, item}) {
      const hasbook = this.readyBooks.find(book => book.bookId === item.bookId)
      if (!hasbook) {
        fetch({
          method: 'patch',
          url: 'meterReading/schedule/updateStatus',
          data: {
            ids: [item.id],
            scheduleStatusId: 'NEW'
          }
        }).then((data) => {
          if (data) {
            this.readyBooks.splice(index, 0, item)
          }
        })
      } else {
        this.readyBooks.splice(index, 0, item)
      }
    },
    /**
     * 修改区本排期
     * @param { String } date - 排期区本的日期
     * @param { Number } index - 排期区本的位置
     * @param { Object } item - 区本项
     */
    changeWorkBooks ({date, data}) {
      const { index, item } = data
      const book = {
        ...item,
        scheduleStatusId: 'SCHEDULED'
      }
      fetchCreate({
        resource: 'meterReading/schedule',
        data: {
          bookIds: [book.bookId],
          readingUserId: this.currentUser,
          workDate: Number(date)
        }
      }).then((data) => {
        if (data) {
          if (this.workBooks[date]) {
            this.workBooks[date].splice(index, 0, book)
          } else {
            this.$set(this.workBooks, date, [book])
          }
        }
      })
    },
    /**
     * 按区本生成抄表任务
     */
    submitTask ({task}) {
      this.buildTask([task])
    },
    /**
     * 按日期生成抄表任务
     */
    submitDay ({tasks}) {
      this.buildTask(tasks)
    },
    /**
     * 生成当前月份所有抄表任务
     */
    submitSchedule () {
      // 抄表任务的日期
      const days = values(this.workBooks)
      // 所有抄表任务列表
      const books = days.reduce((result, books) => [...result, ...books])
      this.buildTask(books)
    },
    /**
     * 生成抄表任务
     * @param { Array } tasks - 排期区本列表
     */
    buildTask (tasks) {
      // 过滤成已排期未生成任务的抄表任务列表
      const scheduleList = tasks.filter(task => {
        return task.scheduleStatusId === 'SCHEDULED' || task.scheduleStatusId === 'GENERAL_FAIL'
      })
      if (scheduleList.length) {
        const text = scheduleList.map(task => `【${task.bookName}】`).join('、')
        this.$swal({
          title: `生成任务`,
          text: text,
          type: 'info',
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText:
            '生成',
          cancelButtonText:
          '取消'
        }).then(() => {
          fetch({
            method: 'put',
            url: 'meterReading/schedule/general',
            data: {
              bookIds: scheduleList.map(item => item.bookId),
              readingUserId: this.currentUser,
              workYearMonth: this.currentMonth
            }
          }).then((data) => {
            // 完成提交生成任务，开始监听生成的任务状态
            this.listenProgress(this.listenProgressTimes + 1)
          })
        }, () => ({}))
      }
    },
    /**
     * 监听进行中的任务
     * @param { Number } times - 第几次监听进行中的任务，用于防止重复监听
     */
    listenProgress (times) {
      // 判断是不是新的监听，是的话更改监听次数
      if (this.listenProgressTimes < times) {
        this.listenProgressTimes = times
      }
      // 判断当前监听是不是最新监听，是的话才执行请求
      if (this.listenProgressTimes === times) {
        fetch({
          method: 'get',
          url: `meterReading/schedule/countInProgress`,
          params: {
            readingUserId: this.currentUser,
            workYearMonth: this.currentMonth
          }
        }).then((data) => {
          if (data) {
            // 判断当前还有没有进行中任务，有才继续监听
            if (data.generatingNum !== 0 || data.readingNum !== 0 || data.backingNum !== 0) {
              const that = this
              this.progressListener = setTimeout(function () {
                that.listenProgress(times)
              }, 3000)
            }
            // 判断当前还有没有进行中任务，没有或者进行中的任务数量有变化，则重新读取区本
            if ((data.generatingNum === 0 && data.readingNum === 0 && data.backingNum === 0) || this.progress.generatingNum !== data.generatingNum || this.progress.readingNum !== data.readingNum || this.progress.backingNum !== data.backingNum) {
              this.progress = data
              this.getBooks()
            }
          }
        })
      }
    },
    /**
     * 将当前排期保存为默认排期
     */
    submitDefault () {
      this.$swal({
        title: `是否保存为默认排期`,
        type: 'question',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText:
          '保存为默认排期',
        cancelButtonText:
        '取消'
      }).then(() => {
        fetch({
          method: 'post',
          url: 'meterReading/scheduleDefault',
          data: {
            readingUserId: this.currentUser,
            workYearMonth: this.currentMonth
          }
        }).then((data) => {
          console.log(data)
        })
      }, () => ({}))
    }
  }
}
</script>

<style lang="sass">
.schedule
  display: flex
  height: 100%
  align-items: stretch
  .schedule-main
    display: flex
    flex-direction: column
    flex: 1
    overflow: auto
    .schedule-toolbar
      padding: 20px
      .schedule-form
        float: left
      .schedule-labelList
        float: right
    .schedule-calendar
      flex: 1
  .schedule-sidebar
    display: flex
    flex-direction: column
    width: 265px
    box-shadow: 0 0 9px rgba(191, 191, 191, 0.36)
    overflow: hidden
    .schedule-monthPicker
      padding: 20px
      border-bottom: 1px solid #ddd
    .schedule-bookList
      flex: 1
      padding: 12px 20px 0
</style>



// WEBPACK FOOTER //
// index.vue?6afbfc6d